/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DailyUserHistoryEvent} from '../models/DailyUserHistoryEvent';
import type {Error} from '../models/Error';

export interface GetAccountActiveUserHistoryEventsByDate$Request {
    accountId: number;
    historyDate: string;
}

export interface GetAccountActiveUserHistoryEventsByDate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountActiveUserHistoryEventsByDateRequest = createAction<PayloadData<void, GetAccountActiveUserHistoryEventsByDate$Request>>('GET_ACCOUNT_ACTIVE_USER_HISTORY_EVENTS__GET_ACCOUNT_ACTIVE_USER_HISTORY_EVENTS_BY_DATE__REQUEST');
export const getAccountActiveUserHistoryEventsByDateSuccess = createAction<PayloadData<Array<DailyUserHistoryEvent>, GetAccountActiveUserHistoryEventsByDate$Request>>('GET_ACCOUNT_ACTIVE_USER_HISTORY_EVENTS__GET_ACCOUNT_ACTIVE_USER_HISTORY_EVENTS_BY_DATE__SUCCESS');
export const getAccountActiveUserHistoryEventsByDateFailure = createAction<PayloadData<Error, GetAccountActiveUserHistoryEventsByDate$Request, true>>('GET_ACCOUNT_ACTIVE_USER_HISTORY_EVENTS__GET_ACCOUNT_ACTIVE_USER_HISTORY_EVENTS_BY_DATE__FAILURE');

export const getAccountActiveUserHistoryEventsByDateActions = [
    getAccountActiveUserHistoryEventsByDateRequest,
    getAccountActiveUserHistoryEventsByDateSuccess,
    getAccountActiveUserHistoryEventsByDateFailure
] as const;

/**
 * Get active user history events for a specific date
 * @param {number} meta.accountId The unique identifier of the account
 * @param {string} meta.historyDate The UTC date for which to retrieve user history events (ISO-8601 format)
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountActiveUserHistoryEventsByDate = (meta: GetAccountActiveUserHistoryEventsByDate$Request, config?: GetAccountActiveUserHistoryEventsByDate$Config) => {
    const TRANSPORT_GET_PARAMS = {
        historyDate: meta.historyDate,
    };
    return {
        CALL_API: {
            types: getAccountActiveUserHistoryEventsByDateActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/users/history`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

